
import { supabase } from "@/integrations/supabase/client";
import { ContentItem } from "@/components/dashboard/content-card/types";

/**
 * Utility function to fetch content items from a specific collection
 * with increased limits for network visualization
 */
export const fetchContentFromCollection = async (collectionId: string, userId: string, currentContentId: string) => {
  console.log(`[NETWORK DEBUG] Fetching content from collection ${collectionId} for user ${userId} excluding ${currentContentId}`);
  
  // Get content IDs that belong to this collection
  const { data: collectionContent, error: collectionError } = await supabase
    .from("content_collections")
    .select("content_id")
    .eq("collection_id", collectionId);

  if (collectionError) {
    console.error("Error fetching collection content:", collectionError);
    return [];
  }

  // If there are no items in this collection, return empty array
  if (!collectionContent || collectionContent.length === 0) {
    console.log(`[NETWORK DEBUG] No content found in collection ${collectionId}`);
    return [];
  }

  // Extract content IDs
  const contentIds = collectionContent.map(item => item.content_id);
  console.log(`[NETWORK DEBUG] Collection ${collectionId} has ${contentIds.length} content IDs`);
  
  // Fetch content items with increased limit
  const { data, error } = await supabase
    .from("content_items")
    .select("*")
    .eq("user_id", userId)
    .eq("archived", false)
    .neq("id", currentContentId)
    .in("id", contentIds)
    .order("created_at", { ascending: false })
    .limit(100);

  if (error) {
    console.error("Error fetching content from collection:", error);
    return [];
  }

  console.log(`[NETWORK DEBUG] Collection content fetched: ${data?.length || 0} items`);
  return data as ContentItem[];
};
